import { Component, Injector } from '@angular/core';
import { FormComponent } from '../core/abstracts/components/form.component';
import { Bezuegestelle } from '../core/models/bezuegestelle';
import { AdresseBezuegestelle } from '../core/models/adresse-bezuegestelle';
import {BezuegestelleService} from "../shared/services/bezuegestelle/bezuegestelle.service";

@Component({
    selector: 'app-odbs',
    templateUrl: './odbs.component.html',
    styleUrls: ['./odbs.component.scss'],
})
export class OdbsComponent extends FormComponent {
    bezuegestelle$ = this._bezuegestelleService.getBezuegestelle$();

    constructor(private injector: Injector, private _bezuegestelleService: BezuegestelleService) {
        super(injector);
    }

    anschriftBezuegestelle(bezuegestelle: Bezuegestelle) {
        if (bezuegestelle !== null) {
            if (bezuegestelle.hauptanschrift) {
                return this.anschriftText(bezuegestelle.hauptanschrift);
            } else if (bezuegestelle.postanschrift) {
                return this.anschriftText(bezuegestelle.postanschrift);
            } else {
                return '';
            }
        }
        return null;
    }

    anschriftText(anschrift: AdresseBezuegestelle) {
        return `${anschrift.strasse} ${anschrift.hausnummer}, ${anschrift.postleitzahl} ${anschrift.ort}`;
    }
}
